// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/layout/Main/global.scss
// module id = c4Al
// module chunks = 7